const features = {
  assets_data_categories: true,
  cemp_digital: true,
}

export default features
